import { render, staticRenderFns } from "./account-assignment-record.vue?vue&type=template&id=271f293d&scoped=true"
import script from "./account-assignment-record.vue?vue&type=script&lang=js"
export * from "./account-assignment-record.vue?vue&type=script&lang=js"
import style0 from "./account-assignment-record.vue?vue&type=style&index=0&id=271f293d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f293d",
  null
  
)

export default component.exports